import "@hotwired/turbo-rails"
import "trix"
import "@rails/actiontext"
import * as popper from "@popperjs/core"
import { Dropdown, Tooltip } from "bootstrap"
import "./controllers"

const bootstrapTooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
bootstrapTooltips.forEach((tooltip) => Tooltip.getOrCreateInstance(tooltip));
